import s1 from '../assets/service/s1.png'
import s2 from '../assets/service/s2.png';
import s3 from '../assets/service/s3.png';
import s4 from '../assets/service/s4.png';
import s5 from '../assets/service/s5.png';
import s6 from '../assets/service/s6.png';
import s7 from '../assets/service/s7.png';
import s8 from '../assets/service/s8.png';
import s9 from '../assets/service/s9.png';
import s10 from '../assets/service/s10.png';
import s11 from '../assets/service/s11.png';
import danger from '../assets/service/danger.png'

const serviceIcons = [
    {
        icon: s1,
        name: 'Lighting / Electrical Systems',
        short: 'Lighting and Electrical'
    },
    {
        icon: s2,
        name: 'Doors / Windows',
        short: 'Doors and Windows'
    },
    {
        icon: s3,
        name: 'Displays / Controls',
        short: 'Displays and Controls'
    },
    {
        icon: s4,
        name: 'Brake / Traction Control',
        short: 'Brake and Traction'
    },
    {
        icon: s5,
        name: 'Steering / Suspension',
        short: 'Steering and Suspension'
    }, 
    {
        icon: s6,
        name: 'Cooling / Heating Systems',
        short: 'Cooling and Heating'
    },
    {
        icon: s7,
        name: 'High Voltage Systems',
        short: 'Voltage Systems'
    },
    {
        icon: s8,
        name: 'Interior Moulding / Trim',
        short: 'Interior and Trim'
    }, 
    {
        icon: s9,
        name: 'Occupant Safety Systems',
        short: 'Occupant Safety Systems'
    },
    {
        icon: s10,
        name: 'Wheels / Tires / Bearings'
    },
    {
        icon: s11,
        name: 'Drivetrain Systems'
    },
    {
        icon: danger,
        name: 'Any Other Issue'
    }
]

export default serviceIcons;